module.exports = __webpack_public_path__ + "img/conny-f-stage5-blink.87da9bf3.png";